import { createAction, props } from "@ngrx/store";
import { SubPage } from "./mobile-navigation.reducer";

export const setRoutes = createAction(
  "[Mobile Nav] SET_ROUTES",
  props<{ subPages: SubPage[] }>()
);

export const reset = createAction("[Mobile Nav] RESET");
